import { Service } from '@/services/Service';
import { RelatedCompaniesService } from '@/services/relations/related-companies.service';
import relations from '@/services/relations/relations.service';
import { BuildingComplexesService } from '@/services/building-complexes.service';

class BuildingComplexRelatedCompaniesService extends Service {
  static entity(relationId) {
    return `${BuildingComplexesService.entity}/${relationId}/${RelatedCompaniesService.entity}`;
  }
}

Object.assign(BuildingComplexRelatedCompaniesService, relations);

export default BuildingComplexRelatedCompaniesService;
